<mat-toolbar>Edit work area</mat-toolbar>
<div class="Dialog-body">
  <form>
    
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input matInput type="text"  [(ngModel)]="selectedName" [ngModelOptions]="{standalone: true}" matInput placeholder="Name">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input matInput type="text"  [(ngModel)]="selectedDescription" [ngModelOptions]="{standalone: true}" matInput placeholder="Description">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <mat-select placeholder="{{'State'}}"   [(ngModel)]="inputValuestate" name="Site" [formControl]="state" required [disabled]="true">            
        <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
          {{Site.SiteName}} </mat-option>
        </mat-select> 
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>

      <div class="buttonbelow">
        <button mat-raised-button (click)="DialogClose()">Cancel</button>    
        <button mat-raised-button (click)="EditWorkarea()">Submit</button>
        
      </div>
  </form>

</div>
